import { render } from "./OtherLoading.vue?vue&type=template&id=5a4a3951&scoped=true"
import script from "./OtherLoading.vue?vue&type=script&lang=js"
export * from "./OtherLoading.vue?vue&type=script&lang=js"

import "./OtherLoading.vue?vue&type=style&index=0&id=5a4a3951&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4a3951"]])

export default __exports__